import { EFilterType, IFilterFormItem, TObjectFilterValue } from 'common/types';
import {
    getExtraFieldsName,
    isExtraChoiceField,
} from 'common/utils/extraFields';
import {
    IRole,
    IUserExtraChoiceField,
    IUserExtraFieldFragment,
} from 'graphql/types';
import { RoleSelectField } from 'user/components/RoleSelectField';
import { IUserExtraFieldsInputOption } from 'user/hooks/useExtraFieldsFilters';
import { translate } from 'utils/i18n';

export function userRolesFilter(
    transKey = 'drawerFilters.userRoles',
    fieldName?: string,
    permissionRoles?: IRole[]
): IFilterFormItem<TObjectFilterValue[]> {
    return {
        key: 'userRoles',
        label: translate(`${transKey}.sectionTitle`),
        permissionRoles,
        fields: [
            {
                name: fieldName || 'userRoles',
                type: EFilterType.Object,
                label: translate(`${transKey}.label`),
                initialValue: [],
                component: RoleSelectField,
                chip: {
                    label: translate(`${transKey}.chip`),
                },
                parseQueryValue: (value) => value.map((role) => role.id),
            },
        ],
    };
}

export function getUserExtraFieldsFilterValues(
    extraUserFields?: IUserExtraFieldFragment[],
    filterValues: Record<string, unknown> = {}
) {
    const extraFieldsObject: Record<string, string[]> = {};

    // Check if extra fields are selected, if so create the correct query object
    extraUserFields
        ?.filter((filter) => isExtraChoiceField(filter))
        .forEach((extraUserField) => {
            const { name, multiple } = extraUserField as IUserExtraChoiceField;

            const filterValueKey = `extraFields-${getExtraFieldsName(name)}`;

            if (multiple) {
                const selectedFilterValues = filterValues[filterValueKey] as
                    | IUserExtraFieldsInputOption[]
                    | undefined;

                if (selectedFilterValues) {
                    extraFieldsObject[name] = selectedFilterValues.map(
                        (selectedFilterValue) => selectedFilterValue.name
                    );

                    delete filterValues[filterValueKey];
                }

                return;
            }

            const selectedFilterValues = filterValues[filterValueKey] as
                | IUserExtraFieldsInputOption
                | undefined;

            if (selectedFilterValues) {
                extraFieldsObject[name] = [selectedFilterValues.name];

                delete filterValues[filterValueKey];
            }
        });

    return !!Object.keys(extraFieldsObject).length
        ? JSON.stringify(extraFieldsObject)
        : undefined;
}
